<template>
  <div class="c-video">
    <el-button v-if="label" type="text" v-preventReclick @click="handleLabelClick" :disabled="!innerSrc">
      <span>{{ label }}</span>
    </el-button>
    <!-- 增加播放伪类元素 -->
    <div class="c-video-wrap" v-else-if="innerUrl">
      <video class="c-video__inner" v-bind="$attrs" :src="innerUrl" @click="handleLabelClick"></video>
    </div>
    <div v-else class="empty flex-center" v-bind="$attrs">暂无视频</div>

    <c-dialog v-if="innerSrc" ref="dialogRef" title="视频预览" no-submit no-padding>
      <div class="flex-center">
        <video  id="myVideo" class="dialog-video" controls autoplay v-bind="$attrs" :src="innerUrl" @ended="ended"></video>
      </div>
    </c-dialog>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { ref, computed, watch, onMounted, useCurrentAppInstance } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    src?: string
    label?: String
    noFaster?: Boolean
    srcType?: 'path' | 'url' // path: 需要请求url才能显示，url: 直接显示
    uploadType?: string
  }>(),
  {
    srcType: 'path'
  }
)
const emit = defineEmits(['ended'])
const app = useCurrentAppInstance()

const { fsApi } = app.apis

const dialogRef = ref<any>()

const innerUrl = ref<string>('')

const innerSrc = computed(() => {
  return (props.src || '').trim()
})

const ended = () => {
  emit('ended', true)
}

// 显示视频(显示本身图片或预览图)
const showVideo = computed(() => {
  return !props.label
})

watch(
  () => [props.src, props.srcType],
  async () => {
    await loadVideoUrl()
  }
)

onMounted(async () => {
  await loadVideoUrl()
})

async function handleLabelClick() {
  if (!innerUrl.value) {
    await loadVideoUrl(true)
  }

  if (!dialogRef.value) return
  dialogRef.value.show()

  if (props.noFaster) {
    setTimeout(() => {
      const video = document.getElementById('myVideo')
      let lastTime = 0

      video.addEventListener('timeupdate', () => {
        if (video.currentTime - lastTime > 1.5) {
          // 检测快进超过1.5秒
          video.currentTime = lastTime // 强制回到之前的时间
          const { MessageBox } = app.useMessage()
          MessageBox.confirm('禁止快进', '重要提示', {
            type: 'error',
            confirmButtonText: '我知道了',
            showCancelButton: false
          })
        } else {
          lastTime = video.currentTime
        }
      })
    }, 0)
  }
}

// 根据文件名获取文件url
async function loadVideoUrl(force = false) {
  // 只有要显示视频时才正式加载
  if (!force && (!showVideo.value || !innerSrc.value)) return

  if (props.srcType === 'url') {
    innerUrl.value = innerSrc.value
  } else {
    const urls = await fsApi.getFileUrls!([innerSrc.value], props?.uploadType)
    innerUrl.value = urls[0]
  }
}
</script>

<style lang="scss" scoped>
.c-video__inner {
  max-height: 100%;
  max-width: 100%;
  cursor: pointer;
}

.c-video-wrap {
  display: inline-block;
  position: relative;

  &::before {
    content: '';
    width: 32px;
    height: 32px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url('../../assets/nav/play.png');
    background-size: 100% 100%;
  }
}

.empty {
  background: #f5f7fa;
  color: var(--el-text-color-placeholder);
  height: 100%;
}

.dialog-video {
  max-height: 50vh;
}
</style>
